// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"7d3125fe","582":"bd861b9f"}[chunkId] + ".chunk.js";
};